const TRACK_DATA = {
	one: 'פרק אחד',
	three: 'שלושה פרקים',
	sefer: 'ספר המצוות',
};

export { TRACK_DATA };